var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ViewFeedItem',{staticClass:"view-feed-systemmessage",scopedSlots:_vm._u([{key:"header",fn:function(){return undefined},proxy:true},{key:"body",fn:function(){return [_c('section',{domProps:{"innerHTML":_vm._s(_vm.html)}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }